export default `var jwt = require('jsonwebtoken');

var PrivateKey = 'YOUR_PRIVATE_SSO_KEY';

function createCannyToken(user) {
  var userData = {
    avatarURL: user.avatarURL, // optional, but preferred
    email: user.email,
    id: user.id,
    name: user.name,
  };
  return jwt.sign(userData, PrivateKey, {algorithm: 'HS256'});
}`;
